<form [formGroup]="formGroup" (submit)="noOp()" class="flex flex-col gap-4">
	<h3>{{ isEditExisting ? 'Edit search list item' : 'Add to search list' }}</h3>

	<div>Please enter the following details to search writs</div>

	<hr />

	<div class="inline-flex">
		<app-radio-group
			formControlName="type"
			[items]="typeOptions"
			label="Search type"
			type="compact"
			class="shrink"
			[testHook]="testHooks.SearchTypeRadioGroup"
		></app-radio-group>
	</div>

	<div class="flex gap-4">
		<ng-container [ngSwitch]="formGroup?.value?.type">
			<ng-container *ngSwitchCase="WRIT_SEARCH_TYPE.PERSON">
				<app-input-wrapper
					label="First name"
					[testHook]="testHooks.FirstNameInputWrapper"
				>
					<app-input
						formControlName="firstName"
						[testHook]="testHooks.FirstName"
					></app-input>
				</app-input-wrapper>

				<app-input-wrapper
					label="Last name"
					[testHook]="testHooks.LastNameInputWrapper"
				>
					<app-input
						formControlName="lastName"
						[testHook]="testHooks.LastName"
					></app-input>
				</app-input-wrapper>
			</ng-container>

			<ng-container *ngSwitchCase="WRIT_SEARCH_TYPE.COMPANY">
				<app-input-wrapper
					label="Company"
					[testHook]="testHooks.CompanyInputWrapper"
				>
					<app-input
						formControlName="name"
						[testHook]="testHooks.Name"
					></app-input>
				</app-input-wrapper>
			</ng-container>

			<ng-container *ngSwitchCase="WRIT_SEARCH_TYPE.EXECUTION">
				<app-input-wrapper
					label="Execution number"
					[testHook]="testHooks.ExecutionNumberInputWrapper"
				>
					<app-input
						formControlName="number"
						[testHook]="testHooks.Number"
					></app-input>
				</app-input-wrapper>
			</ng-container>
		</ng-container>
	</div>

	<div class="flex mt-4">
		<app-button
			mat-dialog-close
			btn="secondary"
			[testHook]="testHooks.CancelButton"
			>Cancel</app-button
		>
		<div class="flex-auto"></div>
		<app-button
			[disabled]="disableSubmit$ | async"
			[mat-dialog-close]="value$ | async"
			[testHook]="testHooks.SearchButton"
		>
			{{ isEditExisting ? 'Update search item' : 'Add to search' }}
		</app-button>
	</div>
</form>
